// @ utilities
const { get } = require('services/api');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const buildEmptySimulation = () => ({
    amount: 0,
    initialContribution: 0,
    selectedPortfolio: '',
    maxTypeOfProduct: 1,
    hasRecurringTransfer: false,
    endDate: '',
    name: '',
    type: '',
    simulationId: '',
});
// @ utilities
const Storage = require('utilities/storage');

const requestSimulationInProgress = () => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_REQUEST,
});

const requestSimulationSuccess = data => {
    const formattedData = !!data ? data : buildEmptySimulation();
    Object.keys(formattedData).forEach(key => formattedData[key] == null && delete formattedData[key]);

    return {
        type: actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS,
        payload: {
            data: formattedData,
        },
    };
};

const requestSimulation =
    (pureRobo = false) =>
    dispatch => {
        // TODO: remove cookie auth token when endpoint is available on onb
        const openBankToken = Storage.cookies.get('openBankToken');
        const requestData = {
            header: {
                openBankAuthToken: openBankToken,
                version: 2,
            },
            query: {
                pureRobo: pureRobo,
            },
        };

        dispatch(requestSimulationInProgress());

        return get(apiURLBuilder.getURL('raSimulation'), requestData)
            .then(response => dispatch(requestSimulationSuccess(response.body)))
            .catch(error => {
                if (error.error) {
                    dispatch(requestSimulationSuccess(buildEmptySimulation()));
                } else {
                    throw error;
                }
            });
    };

const selectStrategy = value => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SELECT_STRATEGY,
    payload: {
        value,
    },
});

const showDetails = () => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SHOW_DETAILS,
});

const setContributionDay = day => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY,
    payload: {
        day,
    },
});

const setPeriodicity = periodicity => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SET_PERIODICITY,
    payload: {
        periodicity,
    },
});

const setHasRecurringContribution = hasRecurringContribution => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SET_HAS_RECURRING_CONTRIBUTION,
    payload: {
        hasRecurringContribution,
    },
});

const setRecurringContributionAmount = amount => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

const setInitialContributionAmount = amount => ({
    type: actionTypes.RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

export default {
    requestSimulation,
    selectStrategy,
    setContributionDay,
    setInitialContributionAmount,
    setPeriodicity,
    setRecurringContributionAmount,
    showDetails,
    setHasRecurringContribution,
};
